import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import Select from '../../commonComponents/util/Select';

export default class ApplyToPledgeModal extends React.Component {
  render() {
    const {
      show,
      close,
      applicantPledgeOptions,
      selectedPledgeId,
      onPledgeChange,
      applyingPledge,
      onApply
    } = this.props;

    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div className="modal warning-modal">
            <div className="modal-header">
              <h4 className="modal-page-header">Apply to Pledge</h4>
            </div>
            <div className="modal-section">
              <div className="modal-row modal-row-full-width">
                <div>
                  <label className="input-label">Pledge</label>
                  <Select
                    clearable={false}
                    options={applicantPledgeOptions}
                    name="selectedPledgeId"
                    value={selectedPledgeId}
                    onChange={onPledgeChange}
                  />
                </div>
              </div>
            </div>
            <div className="modal-btns text-right">
              <button className="btn btn-accent" onClick={close}>
                Cancel
              </button>
              <button
                className="btn btn-accent2"
                disabled={!selectedPledgeId || applyingPledge}
                onClick={onApply}
              >
                {applyingPledge ? 'Applying...' : 'Apply'}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/ApplyToPledgeModal.jsx